const servicePriorities = {
  NOT_PRIORITARY: { value: 0, label: 'notPrioritary', color: '#8c8c8c' },
  LOW_PRIORITY: { value: 1, label: 'lowPriority', color: '#44bff0' },
  MEDIUM_PRIORITY: { value: 2, label: 'mediumPriority', color: '#faad14' },
  HIGH_PRIORITY: { value: 3, label: 'highPriority', color: '#ff3300' },
};

export { servicePriorities };
